module.exports = __webpack_public_path__ + "img/grassi1.489cb180.jpg";